module.exports = __webpack_public_path__ + "assets/videos/video-banner-poster-desktop.jpg?v=e2a17996";